import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { setRiskGapAnswer } from './utils/setRiskGapAnswer';
import { PatientCacheRef, PatientServiceEvents } from './usePatientService';

export interface AddRiskGapParams {
    code: string;
    description: string;
}

export const useAddRiskGap = (events: PatientServiceEvents, patientCache: PatientCacheRef) => {
    const services = React.useContext(ServicesContext);

    const addRiskGap = useCallback(
        async (patientId: number, params: AddRiskGapParams) => {
            const result: ApiDataResponseType<RiskGapType> = await services.api.call({
                method: 'post',
                url: '/api/risk-gaps',
                data: {
                    ...params,
                    patient: { id: patientId },
                    submission_answer: { answer: 1 },
                },
            });

            patientCache.current[patientId].risk_gaps.push(setRiskGapAnswer(result.data));
            services.events.publish(events.patient_updated);
            services.events.publish(events.notes_updated);

            return result.data;
        },
        [services.api, services.events, events, patientCache]
    );

    return addRiskGap;
};
